import React, { useState, useEffect } from "react";
import { Field } from "formik";
import { Row, Col } from "react-bootstrap";

const CareersRegisterSecondaryInterest = (props) => {
  return (
    <div className="careers_register_passport">
      <p>Would you like to get recommendations and learning updates for:</p>
      <div className="careers_register_interested_card">
        <Row>
          {props.secondaryInterestCheckbox?.map((obj) => {
            return (
              <Col key={obj.degree_id} md={12} sm={12} xs={12} className="secondary_border">
                <span className="careers_register_custom_checkbox">
                  <Field
                    type="checkbox"
                    name={"secondary_interest"}
                    id={`int_${obj.degree_id}_${obj.stream_id}`}
                    // value={obj.degree_id}
                    value={props.values?.["secondary_interest"] ? props.values?.["secondary_interest"] : {}}
                    checked={obj.selected}
                    onChange={(name, id) => {
                      props.handleSecondaryDomainCheckbox("secondary_interest", `int_${obj.degree_id}_${obj.stream_id}`);
                    }}
                  />
                  <label className="careers_register_interested_label" htmlFor={`int_${obj.degree_id}_${obj.stream_id}`}>{obj.label}</label>
                </span>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default CareersRegisterSecondaryInterest;

